<div class="trainNav">
    <p class="name">{{trainData.name}}</p>
    <mat-icon title="Edit" (click)="edit()">edit</mat-icon>
    <mat-icon title="Delete" (click)="delete()">delete</mat-icon>
    <mat-icon title="Copy" (click)="copy()">filter_none</mat-icon>
</div>
<div class="trainContainerOuter">
    <div class="trainContainerInner">
        <mat-icon *ngIf="!trainData.trainConfiguration || trainData.trainConfiguration.length===0" class="myIcon"
            (click)="addTrainPart(0)" title="Add Variant">add_circle_outline</mat-icon>
        <div class="trainContainer">
            <div class="trainWagons">
                <div *ngFor="let wagon of trainData.trainConfiguration; let index = index">
                    <app-train-wagon [wagonData]="wagon" [index]="index"
                        [isLastWagon]="trainData.trainConfiguration && index === trainData.trainConfiguration.length - 1"
                        (addEvent)="addTrainPart(index + 1)" (deleteEvent)="deleteTrainPart($event)"
                        (swapPlacesEvent)="swapTrainPart(index)" (rotateEvent)="rotateTrainPart($event)"
                        (editEvent)="editTrainPart(wagon)">
                    </app-train-wagon>
                </div>
            </div>
        </div>
    </div>
</div>